import React, { Component } from 'react'
import { Autocomplete, Box, FormControl, TextField } from '@mui/material'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormInputLabel } from '@/shared/ui/input'
import { CompactButton } from '@/shared/ui/buttons'

class BlockTabQueries extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabQueries: this.props.tabQueries ? this.props.tabQueries : [],
        }
    }

    render() {
        const kedo = this.props.kedo
        return (
            <div>
                <h3>{kedo.t('Tab queries')}</h3>
                <CompactButton
                    variant="contained"
                    onClick={this.props.addTabQuery}
                    title={kedo.t('Add')}
                >
                    <FontAwesomeIcon icon={faPlus} />
                </CompactButton>
                {this.props.tabQueries
                    ? this.props.tabQueries.map((item, index) => (
                          <Box
                              key={`${item.query || 'new'}-${index}`}
                              sx={{ position: 'relative', pt: 1 }}
                          >
                              <CompactButton
                                  dense
                                  variant="contained"
                                  color="error"
                                  title={kedo.t('Remove')}
                                  sx={{
                                      position: 'absolute',
                                      top: 8,
                                      right: 0,
                                  }}
                                  onClick={() =>
                                      this.props.deleteTabQuery(index)
                                  }
                              >
                                  <FontAwesomeIcon icon={faTimes} />
                              </CompactButton>
                              <FormControl fullWidth margin="normal">
                                  <FormInputLabel>
                                      {this.props.kedo.t('Query')}
                                  </FormInputLabel>
                                  <Autocomplete
                                      size="small"
                                      autoHighlight
                                      options={this.props.dossierQueries || []}
                                      getOptionLabel={(option) =>
                                          kedo
                                              .env()
                                              .translateItem(
                                                  option,
                                                  'dossierquery'
                                              ) || ''
                                      }
                                      isOptionEqualToValue={(option, value) =>
                                          String(option.id) === String(value.id)
                                      }
                                      value={
                                          (
                                              this.props.dossierQueries || []
                                          ).find(
                                              (query) =>
                                                  String(query.id) ===
                                                  String(item.query || '')
                                          ) || null
                                      }
                                      onChange={(_event, option) =>
                                          this.props.onChangeTabQueries(
                                              item,
                                              index,
                                              'query',
                                              option ? option.id : ''
                                          )
                                      }
                                      renderInput={(params) => (
                                          <TextField
                                              {...params}
                                              size="small"
                                              placeholder={kedo.t(
                                                  'Choose an option'
                                              )}
                                              sx={{ pr: 5 }}
                                          />
                                      )}
                                  />
                              </FormControl>
                              <FormControl fullWidth margin="normal">
                                  <FormInputLabel>
                                      {this.props.kedo.t('Title')}
                                  </FormInputLabel>
                                  <TextField
                                      size="small"
                                      value={item.title || ''}
                                      onChange={(e) =>
                                          this.props.onChangeTabQueries(
                                              item,
                                              index,
                                              'title',
                                              e.target.value
                                          )
                                      }
                                  />
                              </FormControl>
                          </Box>
                      ))
                    : null}
            </div>
        )
    }
}

export default BlockTabQueries
